/* ─── JHN Suite — styles des applications ───────────────────────────────────── */

/* ══ Login ══ */
.login {
  position: fixed; inset: 0; display: grid; place-items: center; padding: 24px;
}
.login .panel { width: min(420px, 100%); padding: 40px 36px; text-align: center; }
.login .logo { width: 64px; height: 64px; border-radius: 16px; margin: 0 auto 22px; box-shadow: var(--shadow); }
.login h1 { font-size: 27px; margin-bottom: 8px; }
.login p { color: var(--text-dim); font-size: 15px; margin: 0 0 28px; line-height: 1.5; }
.login .rayor-btn {
  width: 100%; height: 52px; font-size: 15.5px; font-weight: 600; border-radius: 15px;
  background: var(--text); color: var(--bg); border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 11px;
  transition: transform 0.12s var(--ease), opacity var(--dur);
}
.login .rayor-btn:hover { opacity: 0.9; }
.login .rayor-btn:active { transform: scale(0.98); }
.login .dev { margin-top: 18px; font-size: 13px; color: var(--text-faint); }
.login .dev a { color: var(--coral); }
.login .foot { margin-top: 26px; font-size: 12px; color: var(--text-faint); }

/* ══ Home / lanceur d'applis ══ */
.hero { margin-bottom: 30px; }
.hero h1 { font-size: clamp(28px, 4vw, 40px); font-weight: 680; line-height: 1.05; }
.hero p { color: var(--text-dim); font-size: 16px; margin-top: 8px; }
.app-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(168px, 1fr)); gap: 16px; }
.app-tile {
  padding: 22px 20px; border-radius: var(--r-md); cursor: pointer; text-align: left;
  background: var(--glass); border: 1px solid var(--border);
  -webkit-backdrop-filter: blur(18px) saturate(170%); backdrop-filter: blur(18px) saturate(170%);
  transition: transform var(--dur) var(--ease), background var(--dur), border-color var(--dur), box-shadow var(--dur);
}
.app-tile:hover { transform: translateY(-4px); background: var(--glass-hover); box-shadow: var(--shadow); border-color: var(--border-strong); }
.app-tile .glyph { width: 46px; height: 46px; border-radius: 13px; display: grid; place-items: center; margin-bottom: 16px; color: #fff; }
.app-tile .glyph svg { width: 24px; height: 24px; }
.app-tile b { font-size: 15.5px; font-weight: 620; display: block; }
.app-tile small { color: var(--text-faint); font-size: 12.5px; }

/* ══ Drive ══ */
.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 22px; flex-wrap: wrap; }
.toolbar h2 { font-size: 22px; margin-right: auto; }
.seg { display: flex; gap: 2px; padding: 3px; border-radius: 12px; background: var(--glass); border: 1px solid var(--border); }
.seg button { width: 34px; height: 30px; border: none; background: transparent; border-radius: 9px; color: var(--text-dim); cursor: pointer; display: grid; place-items: center; }
.seg button.active { background: var(--glass-hover); color: var(--text); }
.seg button svg { width: 17px; height: 17px; }

.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(186px, 1fr)); gap: 14px; }
.tile {
  position: relative; padding: 16px; border-radius: var(--r-md); cursor: pointer;
  background: var(--glass); border: 1px solid var(--border);
  transition: transform 0.18s var(--ease), background var(--dur), border-color var(--dur), box-shadow var(--dur);
}
.tile:hover { background: var(--glass-hover); border-color: var(--border-strong); box-shadow: var(--shadow-sm); transform: translateY(-2px); }
.tile .ic { width: 42px; height: 42px; border-radius: 12px; display: grid; place-items: center; margin-bottom: 30px; color: #fff; }
.tile .ic svg { width: 22px; height: 22px; }
.tile .nm { font-size: 14.5px; font-weight: 560; word-break: break-word; line-height: 1.3; }
.tile .meta { font-size: 12px; color: var(--text-faint); margin-top: 3px; }
.tile .star { position: absolute; top: 14px; right: 13px; color: var(--coral); opacity: 0; }
.tile .star.on { opacity: 1; }
.tile .more { position: absolute; top: 10px; right: 8px; width: 30px; height: 30px; border-radius: 8px;
  display: grid; place-items: center; color: var(--text-dim); opacity: 0; transition: opacity var(--dur), background var(--dur); }
.tile:hover .more { opacity: 1; }
.tile .more:hover { background: var(--glass-strong); }

/* liste */
.list { display: flex; flex-direction: column; }
.list .row { display: flex; align-items: center; gap: 14px; padding: 11px 14px; border-radius: 12px; cursor: pointer; }
.list .row:hover { background: var(--glass); }
.list .row .ic { width: 32px; height: 32px; border-radius: 9px; display: grid; place-items: center; color: #fff; flex: none; }
.list .row .ic svg { width: 17px; height: 17px; }
.list .row .nm { font-weight: 540; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.list .row .meta { color: var(--text-faint); font-size: 13px; width: 160px; text-align: right; }
.list .head { font-size: 12px; color: var(--text-faint); text-transform: uppercase; letter-spacing: 0.06em; padding: 6px 14px; display: flex; }
.list .head .nm { flex: 1; } .list .head .meta { width: 160px; text-align: right; }

/* zone de dépôt de fichiers (import par glisser-déposer) */
.view.drag-over { outline: 2px dashed var(--coral); outline-offset: -12px; background: var(--coral-soft); border-radius: var(--r-md); }

/* ══ Éditeur de document (Docs) ══ */
.editor-wrap { display: flex; flex-direction: column; height: 100%; overflow: hidden; }
.doc-scroll { overflow: auto; padding: 30px 20px 80px; }
.paper {
  width: min(820px, 100%); margin: 0 auto; border-radius: var(--r-md); overflow: hidden;
  background: var(--bg-2); border: 1px solid var(--border); box-shadow: var(--shadow);
}
[data-theme="light"] .paper { background: #fff; }
.doc-title-input {
  width: min(820px, 100%); margin: 0 auto 16px; display: block; background: transparent;
  border: none; outline: none; color: var(--text); font-size: 30px; font-weight: 680; letter-spacing: -0.02em;
}
.doc-title-input::placeholder { color: var(--text-faint); }

/* Quill — adaptation aux thèmes */
.ql-toolbar.ql-snow {
  border: none; border-bottom: 1px solid var(--border); padding: 12px 16px;
  position: sticky; top: 0; z-index: 5; background: var(--glass-strong);
  -webkit-backdrop-filter: blur(18px) saturate(170%); backdrop-filter: blur(18px) saturate(170%);
}
.ql-container.ql-snow { border: none; font-family: var(--font); font-size: 16px; }
.ql-editor { min-height: 60vh; padding: 36px 48px; color: var(--text); line-height: 1.7; }
.ql-editor.ql-blank::before { color: var(--text-faint); font-style: normal; left: 48px; }
.ql-snow .ql-stroke { stroke: var(--text-dim); }
.ql-snow .ql-fill { fill: var(--text-dim); }
.ql-snow .ql-picker { color: var(--text-dim); }
.ql-snow .ql-picker-options { background: var(--glass-strong); border: 1px solid var(--border); border-radius: 12px;
  -webkit-backdrop-filter: blur(20px); backdrop-filter: blur(20px); }
.ql-snow.ql-toolbar button:hover .ql-stroke, .ql-snow .ql-toolbar button:hover .ql-stroke { stroke: var(--coral); }
.ql-snow.ql-toolbar button:hover .ql-fill { fill: var(--coral); }
.ql-snow.ql-toolbar button.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-active .ql-stroke { stroke: var(--coral); }
.ql-snow.ql-toolbar button.ql-active .ql-fill { fill: var(--coral); }
.ql-snow.ql-toolbar button:hover, .ql-snow.ql-toolbar button.ql-active { color: var(--coral); }

/* barre d'outils du doc (titre + partage + présence) */
.doc-bar { display: flex; align-items: center; gap: 12px; }
.doc-bar .save-state { font-size: 12.5px; color: var(--text-faint); display: flex; align-items: center; gap: 6px; }
.doc-bar .save-state .dot { width: 7px; height: 7px; border-radius: 50%; background: #54d18b; }
.doc-bar .save-state.syncing .dot { background: var(--coral); animation: pulse 1s infinite; }
@keyframes pulse { 50% { opacity: 0.3; } }

/* ══ Tableur (Sheets) ══ */
.sheet-wrap { overflow: auto; flex: 1; min-height: 0; padding: 18px; }
table.sheet { border-collapse: collapse; font-size: 13.5px; }
table.sheet th, table.sheet td { border: 1px solid var(--border); min-width: 104px; height: 30px; padding: 0; }
table.sheet th { background: var(--glass-strong); color: var(--text-dim); font-weight: 560; text-align: center;
  position: sticky; top: 0; z-index: 2; }
table.sheet th.rowh { left: 0; z-index: 3; min-width: 46px; width: 46px; }
table.sheet td.rowh { background: var(--glass-strong); color: var(--text-faint); text-align: center; position: sticky; left: 0; z-index: 1; min-width: 46px; width: 46px; }
table.sheet td input { width: 100%; height: 100%; border: none; background: transparent; color: var(--text);
  padding: 0 7px; font: inherit; outline: none; }
table.sheet td input:focus { box-shadow: inset 0 0 0 2px var(--coral); border-radius: 3px; }

/* ══ Slides ══ */
.slides-wrap { display: grid; grid-template-columns: 180px 1fr; gap: 18px; flex: 1; min-height: 0; overflow: hidden; padding: 16px; }
@media (max-width: 760px) { .slides-wrap { grid-template-columns: 96px 1fr; gap: 10px; padding: 10px; } }
.slide-rail { overflow: auto; display: flex; flex-direction: column; gap: 10px; padding: 4px; }
.slide-thumb { aspect-ratio: 16/9; border-radius: 10px; background: var(--glass); border: 1px solid var(--border);
  cursor: pointer; padding: 8px; font-size: 9px; color: var(--text-dim); overflow: hidden; position: relative; }
.slide-thumb.active { border-color: var(--coral); box-shadow: 0 0 0 2px var(--coral-soft); }
.slide-thumb .n { position: absolute; bottom: 4px; left: 6px; font-size: 10px; color: var(--text-faint); }
.slide-stage { display: grid; place-items: center; overflow: auto; }
.slide-canvas {
  aspect-ratio: 16/9; width: min(100%, 880px); border-radius: var(--r-md); padding: 6%;
  background: var(--bg-2); border: 1px solid var(--border); box-shadow: var(--shadow);
  display: flex; flex-direction: column; gap: 16px;
}
[data-theme="light"] .slide-canvas { background: #fff; }
.slide-canvas .s-title { font-size: 34px; font-weight: 680; outline: none; }
.slide-canvas .s-body { font-size: 19px; line-height: 1.5; color: var(--text-dim); outline: none; flex: 1; }
.slide-canvas [contenteditable]:empty::before { content: attr(data-ph); color: var(--text-faint); }

/* ══ Agenda ══ */
.cal-head { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.cal-head h2 { font-size: 21px; text-transform: capitalize; margin-right: auto; }
.cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 1px; background: var(--border);
  border: 1px solid var(--border); border-radius: var(--r-md); overflow: hidden; }
.cal-dow { background: var(--glass-strong); padding: 9px; font-size: 12px; color: var(--text-dim); text-align: center; font-weight: 600; text-transform: capitalize; }
.cal-cell { background: var(--bg); min-height: 112px; padding: 8px; cursor: pointer; transition: background var(--dur); position: relative; }
.cal-cell:hover { background: var(--glass); }
.cal-cell.dim { color: var(--text-faint); }
.cal-cell.today .dnum { background: var(--coral); color: #fff; }
.dnum { display: inline-grid; place-content: center; min-width: 24px; height: 24px; border-radius: 50%; font-size: 13px; font-weight: 560; padding: 0 4px; }
.ev { margin-top: 4px; padding: 3px 7px; border-radius: 6px; font-size: 12px; background: var(--coral-soft);
  color: var(--coral); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 540; }

/* ══ Tasks ══ */
.tasks-cols { display: flex; gap: 16px; align-items: flex-start; overflow-x: auto; padding-bottom: 10px; }
.task-list { width: 300px; flex: none; padding: 14px; }
.task-list .tl-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.task-list .tl-head input { background: transparent; border: none; outline: none; color: var(--text); font-weight: 640; font-size: 15px; flex: 1; }
.task { display: flex; align-items: flex-start; gap: 10px; padding: 9px 8px; border-radius: 10px; }
.task:hover { background: var(--glass); }
.task .chk { width: 19px; height: 19px; border-radius: 50%; border: 2px solid var(--border-strong); cursor: pointer; flex: none; margin-top: 1px; display: grid; place-items: center; transition: all var(--dur); }
.task .chk.on { background: var(--coral); border-color: var(--coral); }
.task .chk.on svg { width: 12px; height: 12px; color: #fff; }
.task .tt { flex: 1; font-size: 14px; }
.task.done .tt { text-decoration: line-through; color: var(--text-faint); }
.task .tt .due { font-size: 12px; color: var(--text-faint); margin-top: 2px; }
.task-add { display: flex; align-items: center; gap: 8px; padding: 8px; color: var(--text-faint); font-size: 14px; cursor: text; }
.task-add input { background: transparent; border: none; outline: none; color: var(--text); flex: 1; font-size: 14px; }

/* ══ Admin ══ */
.admin-list { display: flex; flex-direction: column; margin-top: 4px; }
.admin-row { display: grid; grid-template-columns: 1fr 230px 80px; align-items: center; gap: 16px; padding: 12px 14px; border-radius: 12px; }
.admin-row:not(.admin-head):hover { background: var(--glass); }
.admin-head { font-size: 11px; text-transform: uppercase; letter-spacing: 0.07em; color: var(--text-faint); font-weight: 650; }
.admin-user { display: flex; align-items: center; gap: 11px; min-width: 0; }
.admin-name { font-size: 14.5px; font-weight: 600; cursor: pointer; }
.admin-name:hover { color: var(--coral); text-decoration: underline; }
.admin-email { font-size: 12.5px; color: var(--text-faint); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.admin-storage { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--text-dim); }
.admin-storage .bar { height: 6px; border-radius: 99px; background: var(--border-strong); overflow: hidden; }
.admin-storage .bar i { display: block; height: 100%; background: linear-gradient(90deg, var(--coral), #f4a78f); }
.admin-items { text-align: right; font-size: 14px; color: var(--text-dim); }
@media (max-width: 700px) { .admin-row { grid-template-columns: 1fr 120px; } .admin-items { display: none; } }

/* ══ Meet ══ */
.meet-soon { display: grid; place-items: center; text-align: center; gap: 14px; padding: 80px 20px; }
.meet-soon .badge { padding: 5px 12px; border-radius: 99px; background: var(--coral-soft); color: var(--coral); font-size: 12px; font-weight: 620; }

.meet { display: flex; flex-direction: column; height: 100%; background: #060606; }
.meet-stage { position: relative; flex: 1; min-height: 0; display: grid; place-items: center; overflow: hidden; }
.meet-stage > video { width: 100%; height: 100%; object-fit: cover; background: #000; }
.meet-status { position: absolute; color: rgba(255,255,255,.82); font-size: 15px; text-align: center; padding: 24px; max-width: 80%; }
.meet-pip { position: absolute; right: 16px; bottom: 16px; width: clamp(110px, 26vw, 210px); aspect-ratio: 4/3;
  border-radius: 14px; overflow: hidden; box-shadow: 0 8px 26px rgba(0,0,0,.55); border: 1px solid rgba(255,255,255,.16); background: #111; }
.meet-pip video { width: 100%; height: 100%; object-fit: cover; }
.meet-bar { display: flex; align-items: center; justify-content: center; gap: 14px;
  padding: 16px; padding-bottom: calc(16px + env(safe-area-inset-bottom)); background: rgba(0,0,0,.55);
  -webkit-backdrop-filter: blur(14px); backdrop-filter: blur(14px); }
.meet-ctrl { width: 54px; height: 54px; border-radius: 50%; border: none; cursor: pointer; display: grid; place-items: center;
  color: #fff; background: rgba(255,255,255,.15); transition: background .2s, transform .1s; }
.meet-ctrl:hover { background: rgba(255,255,255,.26); }
.meet-ctrl:active { transform: scale(.94); }
.meet-ctrl.off { background: #fff; color: #111; }
.meet-ctrl.on { background: var(--coral); }
.meet-hang { background: #e23d3d; }
.meet-hang:hover { background: #c92f2f; }
@media (max-width: 600px) { .meet-ctrl { width: 50px; height: 50px; } .meet-bar { gap: 10px; } }
